import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["className", "dataTestId", "hideLabel", "isInline", "label", "labelMaxWidth", "labelVariant", "loaderSize"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { getHexToRgb, typographyButton, typographyGroupLabel, visuallyHidden } from "../../core";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LOADER_SIZE, LOADER_LABEL_VARIANTS } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var StyledLabel = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  color: inherit;\n  line-height: 1;\n  margin-left: ", ";\n  ", "\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyButton(theme);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.size.spacing.medium.value;
}, function (_ref3) {
  var hideLabel = _ref3.hideLabel;
  return hideLabel && visuallyHidden;
}, function (_ref4) {
  var isInline = _ref4.isInline,
      labelMaxWidth = _ref4.labelMaxWidth,
      labelVariant = _ref4.labelVariant,
      loaderSize = _ref4.loaderSize,
      theme = _ref4.theme;
  return (labelVariant === LOADER_LABEL_VARIANTS.INDETERMINATE || labelVariant === LOADER_LABEL_VARIANTS.DETERMINATE) && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n      color: ", ";\n      font-size: ", ";\n      margin-left: ", ";\n      max-width: ", ";\n      min-width: ", ";\n      overflow-wrap: break-word;\n      padding-top: 1px;\n      word-wrap: break-word;\n    "])), typographyGroupLabel(theme), function (_ref5) {
    var theme = _ref5.theme;
    return "rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.7)");
  }, loaderSize === LOADER_SIZE.SMALL ? theme.font.size.body1.value : theme.font.size["default"].value, function (_ref6) {
    var theme = _ref6.theme;
    return theme.size.spacing.medium.value;
  }, isInline ? '194px' : labelMaxWidth, isInline ? 'inherit' : '100px');
});
export var LoaderLabel = function LoaderLabel(_ref7) {
  var className = _ref7.className,
      dataTestId = _ref7.dataTestId,
      hideLabel = _ref7.hideLabel,
      isInline = _ref7.isInline,
      label = _ref7.label,
      labelMaxWidth = _ref7.labelMaxWidth,
      labelVariant = _ref7.labelVariant,
      loaderSize = _ref7.loaderSize,
      other = _objectWithoutProperties(_ref7, _excluded);

  return label ? /*#__PURE__*/_jsx(StyledLabel, _objectSpread(_objectSpread({
    className: className,
    "data-testid": dataTestId ? "".concat(dataTestId, "-label") : undefined,
    hideLabel: hideLabel,
    isInline: isInline,
    labelMaxWidth: labelMaxWidth,
    loaderSize: loaderSize,
    labelVariant: labelVariant
  }, other), {}, {
    children: label
  })) : null;
};
LoaderLabel.propTypes = {
  /** Adds additional class name to the label for styling */
  className: PropTypes.string,

  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** If true, label will set a max-width before text will wrap on the word. */
  isInline: PropTypes.bool,

  /** Visually hides loader text */
  hideLabel: PropTypes.bool,

  /** Adds label text  */
  label: PropTypes.node,

  /** Determines the max-width of the label  */
  labelMaxWidth: PropTypes.string,

  /** Sets the size of the loader to small or large */
  loaderSize: PropTypes.oneOf(Object.values(LOADER_SIZE)),

  /**  The type of loader label */
  labelVariant: PropTypes.oneOf(Object.values(LOADER_LABEL_VARIANTS))
};
LoaderLabel.defaultProps = {
  className: '',
  dataTestId: '',
  isInline: false,
  hideLabel: false,
  label: 'loading...',
  labelMaxWidth: '500px',
  loaderSize: LOADER_SIZE.LARGE,
  labelVariant: undefined
};